import MicroModal from 'micromodal';
import PubSub from 'pubsub-js'

import {
    Controller
} from "stimulus"

export default class extends Controller {
    openSubscriptionToken
    closeSubscriptionToken

    get config() {
        return {
            disableScroll: true
        }
    }

    get id() {
        return this.data.get('id')
    }

    get autoOpen() {
        return this.data.get('autoOpen')
    }

    connect() {
        if (this.autoOpen) {
            this.open()
        }

        this.openSubscriptionToken = PubSub.subscribe('MODAL_OPEN', (event, id) => {
            if (id === this.id) {
                this.open()
            }
        });

        this.closeSubscriptionToken = PubSub.subscribe('MODAL_CLOSE', (event, id) => {
            if (id === this.id) {
                this.close()
            }
        });
    }

    open() {
        MicroModal.show(this.id, this.config)
    }

    close() {
        MicroModal.close(this.id)
    }

    disconnect() {
        PubSub.unsubscribe(this.openSubscriptionToken)
        PubSub.unsubscribe(this.closeSubscriptionToken)

    }
}
